import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IonSelect } from '@ionic/angular';
import { Common } from 'src/app/models/Common';

@Component({
  selector: 'app-a-select',
  templateUrl: './a-select.component.html',
  styleUrls: ['./a-select.component.scss'],
})
export class ASelectComponent implements OnInit {
  @Input() paddingPx: string = "5px";
  @Input() validations: string[] = [];
  @Input() validationObject: Common;

  @Input() objectList: any[] = [];
  @Input() multiple: boolean = false;
  @Input() type: string = "String";
  @Input() display: string = "name";
  @Input() display2: string;
  @Input() label: string;
  @Input() variable: any;
  @Input() isMandatory: boolean = false;
  @Input() value: string;
  @Output() variableChange = new EventEmitter<any>();
  @Input() openSelection = false;
  @Input() disabled = false;

  validationMessage: string = null;
  @Input() interface = "popover";
  mandatoryError: string = "";
  @ViewChild('mySelect') select: IonSelect;
  constructor() { }

  ngOnInit() {
    if (this.validations && this.validations.length > 0) {
      this.label = this.label + " *";
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes, this.validations);
    if (this.validations.includes("Check Validation")) {
      this.checkValidation();
    }
    if (this.openSelection) {
      this.select.open();
    }
  }

  editInput() {
    this.openSelection = false;
    this.checkValidation();

    // console.log(this.variable);
    this.variableChange.emit(this.variable);
  }

  checkValidation() {
    if (this.validationObject) {
      this.validationMessage = null;
      if (!this.validationObject.pageValidation || this.validationObject.pageValidation.set == null) {
        this.validationObject.pageValidation = new Map();
        // console.log(this.validationObject.pageValidation);
      }
      // console.log(this.validationObject.pageValidation);
      this.validationObject.pageValidation.set(this.label, []);
      for (let valid of this.validations) {
        switch (valid) {
          case "name": {
            let nameRegex = /^[a-zA-Z ]+$/g;
            if (!nameRegex.test(this.variable)) {
              this.validationMessage = this.label + " should have valid character";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }
          case "email": {
            let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let nameRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
            if (!nameRegex.test(this.variable)) {
              this.validationMessage = this.label + " should have valid email";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }
          case "mobile": {
            let nameRegex = /^[0-9]{10}$/g;
            if (!nameRegex.test(this.variable)) {
              this.validationMessage = this.label + " should have valid 10 digits";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }
          case "mandatory": {
            if (this.variable == null) {
              this.validationMessage = this.label + " is Mandatory";
              this.validationObject.pageValidation.get(this.label).push(this.validationMessage);
            }
            break;
          }
        }
      }
    }
  }

}
